import { useReframe } from 'nike-re-framejs';
import { selectedMarketIds$$, sportMaxColumns$$ } from '../push/overview/subs';
import { useRouteMatch } from 'react-router-dom';
import { TURBO_LIVE_SPORT_PATH } from '../../../common/routing';
import { useMatchMedia } from './useMatchMedia';
import useMediaColsCount from './useMediaColsCount';
import useLandscape from '../../../hooks/useLandscape';
import { isMobileChannel } from '../../../common/util';
import { isProfileBookingLandscapeEnabled } from '../../../profiles';

const useMarketIds = (sportName: string) => {
    const derefSub = useReframe();
    const landscape = useLandscape() && isProfileBookingLandscapeEnabled();
    const matchMedia = useMatchMedia();
    const maxMediaCols = useMediaColsCount();
    const selectedMarketIds = derefSub(selectedMarketIds$$(sportName));
    const sportMaxCols = derefSub(sportMaxColumns$$(sportName));
    const getSportPath = useRouteMatch({ path: TURBO_LIVE_SPORT_PATH, strict: true });
    const isOverview = getSportPath?.isExact;
    const detailColsCount = (!isMobileChannel() && matchMedia.x_1680) || landscape ? 1 : 0;
    const selectedMarketIdsSize = selectedMarketIds?.size || 0;
    const colsCount = isOverview ? Math.min(sportMaxCols, selectedMarketIdsSize, maxMediaCols) : detailColsCount;

    return selectedMarketIds?.take(colsCount);
};

export default useMarketIds;
